import { Keys } from '@eih-netbroker/common';
import { IDBPObjectStore } from 'idb';
import { IDB } from '../../utils/idb';
import { CookieUtils } from '../../utils/useCookie';

export class SseEventLogger extends IDB {
  static storeName: string = 'eStreamRaw';
  private static instance: SseEventLogger;

  static async clearDb() {
    const instance = new IDB(SseEventLogger.storeName);
    await instance.create();
    await instance.delete();
  }

  static async getInstance() {
    if (!SseEventLogger.instance) {
      SseEventLogger.instance = new SseEventLogger(SseEventLogger.storeName);
      await SseEventLogger.instance.create();
    }
    return SseEventLogger.instance;
  }

  static getLogger(): ((message: any) => void) | null {
    const eStreamRawEnabled = !!CookieUtils.getCookie(Keys.Cookie.AppDebugEStreamRaw);
    if (!eStreamRawEnabled) {
      return null;
    }
    if (!SseEventLogger.instance) {
      SseEventLogger.instance = new SseEventLogger(SseEventLogger.storeName);
      SseEventLogger.instance.create();
    }
    return SseEventLogger.instance.log.bind(SseEventLogger.instance);
  }

  setupIndexes(store: IDBPObjectStore<any, any, `store`, 'versionchange'>) {
    super.setupIndexes(store);
    store.createIndex('ric', 'ric');
    store.createIndex('timestamp', 'timestamp');
  }

  async findByRic(ric: string) {
    if (!this.db) {
      throw new Error('Database not initialized');
    }

    return this.db.getAllFromIndex(`store`, 'ric', ric);
  }

  async filterByDate(from: Date, to: Date) {
    if (!this.db) {
      throw new Error('Database not initialized');
    }
    const tx = this.db?.transaction(`store`, 'readwrite');
    if (!tx) {
      throw new Error('Failed to create transaction');
    }

    const dateRange = IDBKeyRange.bound(from, to);
    const index = tx.store.index('timestamp');
    return await index.getAll(dateRange);
  }
}
